exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".code-active[data-v-658622e7]{border:1px solid #343646!important}.code-box[data-v-658622e7]{width:100%;position:relative;overflow-x:hidden}.code-box>.code-input[data-v-658622e7]{position:absolute;width:300%;left:-200%;z-index:-1;opacity:0}.code-box>.code-all[data-v-658622e7]{padding:60px 30px 0;display:flex;align-content:space-between}.code-box>.code-all>.code-item[data-v-658622e7]{flex:1;width:20px;font-size:24px;line-height:60px;text-align:center;margin:0 15px;background:transparent;border:1px solid #8a8a8a;outline:none}.code-box>.code-all .code-item.code-password[data-v-658622e7]{position:relative}.code-box>.code-all .code-item.code-password[data-v-658622e7]:after{position:absolute;content:\"\";top:50%;left:50%;transform:translate(-50%,-50%);width:6px;height:6px;background:#000;border-radius:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-658622e7","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/verification-code/verification-code.vue
// module id = 5
// module chunks = 0